export default "__VITE_ASSET__GI4mUJi7__"